export enum TableStatus {
  Available = 0,
  Occupied = 1,
  Reserved = 2,
}

export interface RestaurantTable {
  id: string;
  tableNumber: number;
  restaurantId: string;
  status: TableStatus;
  capacity: number | null;
  notes: string | null;
}

export interface TableState {
  restaurantTables: RestaurantTable[];
  selectedTable?: RestaurantTable;
  qrCode?: string;
  status: 'idle' | 'loading' | 'error';
  error: string | null;
}

export interface TableFormData {
  tableNumber: number;
  status: TableStatus;
  capacity: number | null;
  notes: string | null;
}

export interface TableFormProps {
  restaurantId: string;
  tableId?: string;
  tableNumber?: number;
  onCancel: () => void;
}

export interface QrCodeProps {
  restaurantId: string;
  tableNumber: string;
}

export interface QrCodeControlsProps {
  customText: string;
  selectedSize: number;
  isDownloading: boolean;
  onCustomTextChange: (text: string) => void;
  onSizeChange: (size: number) => void;
  onDownload: () => void;
  onPrint: () => void;
}

export interface DeleteTableParams {
  restaurantId: string;
  tableId: string;
}

export interface CreateTableParams {
  restaurantId: string;
  tableNumber: number;
}

export interface UpdateTableParams extends CreateTableParams {
  tableId: string;
}
